/**
 * @file
 * A JavaScript file for the site.
 *
 * @copyright Copyright 2022 Palantir.net
 */

// JavaScript should be made compatible with libraries other than jQuery by
// wrapping it with an "anonymous closure". See:

// - http://www.adequatelygood.com/2010/3/JavaScript-Module-Pattern-In-Depth

(function ($) {
  let bio = document.querySelector('.js-read-more');
  if(bio !=null) {
  let orgHtml = bio.innerHTML;
  let newHtml = '<div class="content-wrap">' + orgHtml + '</div><a class="button-text read-more-btn" href="#" aria-expanded="false">' + dictionary.ReadMore + '</a>';
  bio.innerHTML = newHtml;
  bio.closest('.anchor-content__content').classList.contains('accordion__content') ? bio.closest('.anchor-content__content').style.display = "block" : '';
  let pHeight = ((bio.querySelector('.content-wrap > p') && bio.querySelector('.content-wrap > p').offsetHeight > 0) ? bio.querySelector('.content-wrap > p').offsetHeight : '239');
  bio.closest('.anchor-content__content').classList.contains('accordion__content') ? bio.closest('.anchor-content__content').style.display = "none" : '';
  bio.querySelector('.content-wrap').style.height = pHeight+'px';
  const readMoreBtn = document.querySelector('.read-more-btn');
  readMoreBtn.addEventListener("click", function (e) {
    e.preventDefault();
    const expanded = readMoreBtn.getAttribute('aria-expanded') === 'true';
    if (expanded) {
      bio.querySelector('.content-wrap').style.height = pHeight+'px';
      readMoreBtn.setAttribute('aria-expanded', 'false');
      readMoreBtn.textContent = dictionary.ReadMore;
    } else {
      bio.querySelector('.content-wrap').style.height = 'auto';
      readMoreBtn.setAttribute('aria-expanded', 'true');
      readMoreBtn.textContent = dictionary.ReadLess;
    }
  });
  }
}(jQuery));